// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_secret.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppSecretSearch } from "./app_secret";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { SearchAppSecretsWithAlertCountResponse } from "./app_secret";
import type { SearchAppSecretsWithAlertCountRequest } from "./app_secret";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppSecretSearch
 */
export interface IAppSecretSearchClient {
    /**
     * @generated from protobuf rpc: SearchAppSecretsWithAlertCount(c1.api.app.v1.SearchAppSecretsWithAlertCountRequest) returns (c1.api.app.v1.SearchAppSecretsWithAlertCountResponse);
     */
    searchAppSecretsWithAlertCount(input: SearchAppSecretsWithAlertCountRequest, options?: RpcOptions): UnaryCall<SearchAppSecretsWithAlertCountRequest, SearchAppSecretsWithAlertCountResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppSecretSearch
 */
export class AppSecretSearchClient implements IAppSecretSearchClient, ServiceInfo {
    typeName = AppSecretSearch.typeName;
    methods = AppSecretSearch.methods;
    options = AppSecretSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchAppSecretsWithAlertCount(c1.api.app.v1.SearchAppSecretsWithAlertCountRequest) returns (c1.api.app.v1.SearchAppSecretsWithAlertCountResponse);
     */
    searchAppSecretsWithAlertCount(input: SearchAppSecretsWithAlertCountRequest, options?: RpcOptions): UnaryCall<SearchAppSecretsWithAlertCountRequest, SearchAppSecretsWithAlertCountResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppSecretsWithAlertCountRequest, SearchAppSecretsWithAlertCountResponse>("unary", this._transport, method, opt, input);
    }
}
